<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div :class="['title', 'big']">
            {{ title }}
          </div>
          <div :class="['desc', { red: isFailure, green: !isFailure }]">
            {{ description }}
          </div>

          <div class="actions">
            <RouterLink :to="{ name: 'Profile', params: { page: 'offers' } }">
              <button class="button">
                <span>{{
                  isFailure ? $t("Try again") : $t("My profile")
                }}</span>
              </button>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "PayoutResultPage",
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => ["success", "failure"].includes(value),
    },
    message: {
      type: String,
      default: "",
    },
  },
  computed: {
    isFailure() {
      return this.status === "failure";
    },
    title() {
      return this.isFailure
        ? this.$t("Payout Request Failed")
        : this.$t("Your Payout Request Has Been Submitted");
    },
    description() {
      if (this.message) {
        return this.message;
      }
      return this.isFailure
        ? this.$t(
            "Sorry, something went wrong while processing your payout. Please try again later or contact support."
          )
        : this.$t(
            "Your funds will be transferred to your bank account shortly."
          );
    },
  },
};
</script>

<style scoped>
.profile-page .hero-section .wrapper {
  justify-content: center;
}
.page-inside .hero-section .wrapper > .title {
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  text-align: center;
}

.desc {
  margin-bottom: 20px;
  text-align: center;
}

.actions {
  display: flex;
  justify-content: center;
}
</style>
